import { get } from 'lodash'
import { Component } from 'react'
import styled from 'styled-components'

import * as cardUtilities from '@/utilities/client-components/utilities/cardUtilities'
import OpenUrl from '@/utilities/client-components/utilities/OpenUrl'

import ActionSet from './ActionSet'
import AdaptiveCardBody from './AdaptiveCardBody'
import Header from './Header'
import StyledAdaptiveCard from './StyledAdaptiveCard'

const StyledFullscreen = styled.div`
  padding: ${(props: any) => get(props.theme, 'spacing.padding', 0)}px;
`

interface ErrorAdaptiveCardProps {
  className?: string
  error: {
    code?: string
  }
  errorContact?: {
    link?: string
  }
  fullscreen?: boolean
  id?: string
  message?: string
  title?: string
}

class ErrorAdaptiveCard extends Component<ErrorAdaptiveCardProps> {
  handleAction = (type: any, title: any, actionInformation: any) => {
    switch (type) {
      case 'Action.OpenUrl': {
        OpenUrl(get(actionInformation, 'url', ''))
        break
      }
      case 'Action.Submit': {
        // The submit action is reload browser
        // @ts-expect-error
        window.location.reload(true)
        break
      }
    }
  }

  render() {
    const { error, title, id, fullscreen, errorContact, className } = this.props
    const additionalActions = []
    let message = ''
    if (get(error, 'code') && error.code === 'TOKEN-1') {
      message =
        'You have been logged out, click the "Reload" button to log back in. \n\n __This will reload the entire page, save your work!__'
      additionalActions.push({
        type: 'Action.Submit',
        data: { action: 'refresh' },
        title: 'Reload this page',
        color: 'primary'
      })
    }

    if (get(errorContact, 'link')) {
      message = 'Click the "Contact Us" button to report this issue. If possible mention the following code:'
      additionalActions.push({
        type: 'Action.OpenUrl',
        // @ts-expect-error
        url: errorContact.link,
        title: 'Contact Us',
        color: 'primary'
      })
    }

    const notification = cardUtilities.getErrorCard({
      id,
      title,
      code: get(error, 'code', 'UNCOMMON'),
      additionalActions,
      message
    })
    const card = notification.card

    const ErrorCard = fullscreen ? StyledFullscreen : StyledAdaptiveCard

    return (
      <ErrorCard
        className={className}
        id={notification.id}
        data-id={'wg-error-ac-card'}
        // @ts-expect-error
        priority={notification.priority}
        hasActions={!!card.actions && card.actions.length > 0}
      >
        {/* @ts-expect-error */}
        {!!notification.source && <Header source={notification.source} />}
        <AdaptiveCardBody
          actionHandler={() => {}}
          body={card.body}
          notificationId={notification.id}
          registerInputCallback={() => {}}
        />
        {card.actions && card.actions.length > 0 ? (
          <ActionSet actions={card.actions} actionHandler={this.handleAction} />
        ) : (
          ''
        )}
      </ErrorCard>
    )
  }
}

// @ts-expect-error
ErrorAdaptiveCard.displayName = 'ErrorAdaptiveCard'

// @ts-expect-error
ErrorAdaptiveCard.defaultProps = {
  error: {}
}

export default ErrorAdaptiveCard
